export default function (influencer) {
  if (influencer.subgenres) {
    const out = Object.keys(influencer.subgenres).reduce(
      function (accumulator, key) {
        const elem = influencer.subgenres[key]

        accumulator.genres.add(elem.genre)
        accumulator.subgenres.push(elem.name)
        return accumulator
      },
      { genres: new Set(), subgenres: [] }
    )

    return out
  } else return {}
}
